import React from 'react'
import { MAXIMUM_FRACTION_DIGITS_BY_CURRENCY, PRICE_LOCALE_BY_CURRENCY } from '../../mappings'

interface Props {
  currency: string
  minAmount: number
  maxAmount: number
  options?: Intl.NumberFormatOptions
}

const FormattedPriceRange: React.FC<Props> = ({ currency, minAmount, maxAmount, options = {} }) => {
  const locale = PRICE_LOCALE_BY_CURRENCY[currency.toUpperCase()] || 'en-US'
  if (minAmount === maxAmount) {
    return (
      <>
        {new Intl.NumberFormat(locale, {
          ...options,
          style: 'currency',
          currency: currency.toUpperCase(),
          currencyDisplay: 'narrowSymbol',
          maximumFractionDigits: MAXIMUM_FRACTION_DIGITS_BY_CURRENCY[currency.toUpperCase()],
        }).format(minAmount)}
      </>
    )
  }
  return (
    <>
      {new Intl.NumberFormat(locale, {
        ...options,
        style: 'currency',
        currency: currency.toUpperCase(),
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: MAXIMUM_FRACTION_DIGITS_BY_CURRENCY[currency.toUpperCase()],
      }).format(minAmount)}{' '}
      -{' '}
      {new Intl.NumberFormat(locale, {
        ...options,
        style: 'currency',
        currency: currency.toUpperCase(),
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: MAXIMUM_FRACTION_DIGITS_BY_CURRENCY[currency.toUpperCase()],
      }).format(maxAmount)}
    </>
  )
}

export default FormattedPriceRange
